export default __webpack_public_path__ + "static/media/infoLogo.229612f3.webp";